import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query widgetSites {
  widgetSites
}`;

function getWidgetSites() {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
  }).then((res) => res.data.widgetSites);
}

export default getWidgetSites;
